module.exports = __webpack_public_path__ + "img/logo_7.4b4a2fd8.png";